<template>
  <div
    id="main-app"
    class="app header-fixed aside-menu-fixed aside-menu-hidden"
  >
    <!-- <PromoBanner v-if="!$route.meta.quiet" /> -->
    <RouterView />
    <TermsBanner />
    <Request2FA />
    <CreateMeeting />
    <SupportWidget />

    <notifications position="bottom center" />

    <div
      v-if="loading"
      class="screen-loading position-fixed d-flex align-items-center justify-content-center"
    >
      <div class="p-4 rounded bg-white">
        <NanLoading />
      </div>
    </div>
  </div>
</template>

<script>
import CreateMeeting from "@/components/meetings/CreateMeeting";
// import PromoBanner from "@/components/misc/PromoBanner";
import Request2FA from "@/components/2fa/Request2FA";
import SupportWidget from "@/components/SupportWidget";
import TermsBanner from "@/components/misc/TermsBanner";

export default {
  name: "app",
  components: {
    CreateMeeting,
    // PromoBanner,
    Request2FA,
    SupportWidget,
    TermsBanner
  },

  metaInfo: {
    title: "Nanome"
  },

  data: () => ({
    loading: false,
    loadingTid: null
  }),

  watch: {
    // delay showing loading spinner by 200ms to avoid flicker
    "$store.state.pendingRequests": {
      handler(value) {
        if (!value) {
          clearTimeout(this.loadingTid);
          this.loadingTid = null;
          this.loading = false;
        } else if (!this.loading && !this.loadingTid) {
          this.loadingTid = setTimeout(() => {
            this.loading = true;
          }, 200);
        }
      },
      immediate: true
    }
  },

  created() {
    const onUnload = () => {
      this.$store.dispatch("cart/sendCartData", this.$store.state.user.email);
    };
    window.addEventListener("unload", onUnload, false);

    document.body.addEventListener("click", e => {
      document.body.classList.add("using-mouse");
      if (e.target.tagName === "BUTTON") e.target.blur();
    });

    document.body.addEventListener("keydown", e => {
      if (e.keyCode === 9) {
        document.body.classList.remove("using-mouse");
      }
    });
  }
};
</script>

<style lang="scss">
.screen-loading {
  z-index: 1020;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
svg {
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 0;
  &.icon {
    display: inline-block;
    width: 1em;
    height: 1em;
  }
  &.icon-logo {
    width: 6em;
  }
}
body.using-mouse :focus,
body.using-mouse .focus {
  box-shadow: none !important;
  outline: none !important;
}
</style>
